import React, { createContext, useContext, useState } from 'react';
import CustomAlert from './CustomAlert';

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const showAlert = (message, type = 'success', duration = 3000) => {
    const id = Date.now() + Math.random();
    const newAlert = { id, message, type, duration };
    
    setAlerts(prev => [...prev, newAlert]);
    
    // ลบ alert อัตโนมัติหลังจากหมดเวลา
    if (duration > 0) {
      setTimeout(() => {
        removeAlert(id);
      }, duration);
    }
  };

  const removeAlert = (id) => {
    setAlerts(prev => prev.filter(alert => alert.id !== id));
  };

  const clearAllAlerts = () => {
    setAlerts([]);
  };

  return (
    <AlertContext.Provider value={{ showAlert, removeAlert, clearAllAlerts }}>
      {children}
      {/* แสดง alerts ทั้งหมด */}
      {alerts.map((alert, index) => (
        <div key={alert.id} style={{ top: `${20 + (index * 80)}px` }}>
          <CustomAlert
            message={alert.message}
            type={alert.type}
            onClose={() => removeAlert(alert.id)}
            duration={0} // ไม่ auto-close เพราะจัดการเอง
          />
        </div>
      ))}
    </AlertContext.Provider>
  );
}; 